// src/pages/VistaProyecto.js
//
// Vista dedicada del documento estratégico para el rol INVERSIONISTA.
// Reutiliza el componente AdminProyecto (con sus 3 tabs) pero sin el
// sidebar del panel admin. Header propio con logout.

import React from 'react';
import { Box, AppBar, Toolbar, Container, Button, Typography, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import DescriptionIcon from '@mui/icons-material/Description';

import Logo from '../components/Logo';
import { useApp } from '../context/AppContext';
import AdminProyecto from './admin/AdminProyecto';

export default function VistaProyecto() {
  const { sesionBackend, cerrarSesionBackend } = useApp();
  const navigate = useNavigate();

  const salir = async () => {
    await cerrarSesionBackend();
    navigate('/login', { replace: true });
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#FBF7F0' }}>
      <AppBar position="sticky" color="default" elevation={1}>
        <Toolbar>
          <Logo />
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 2 }}>
            <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32 }}>
              <DescriptionIcon fontSize="small" />
            </Avatar>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.1 }}>
                {sesionBackend?.nombre || 'Inversionista'}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1 }}>
                Vista de inversionista
              </Typography>
            </Box>
          </Box>
          <Button startIcon={<LogoutIcon />} onClick={salir}>Salir</Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ py: 3 }}>
        <AdminProyecto />
      </Container>
    </Box>
  );
}
